export class admCatOccupations {
}